import { render, staticRenderFns } from "./ComplaintClose.vue?vue&type=template&id=0e41683c&"
import script from "./ComplaintClose.vue?vue&type=script&lang=js&"
export * from "./ComplaintClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports